import queryString from 'query-string';
import useReactRouter from 'use-react-router';

export const useUrlParameters = () => {
  const {
    location: { search: query },
  } = useReactRouter();
  return queryString.parse(query);
};
